import { Box, styled } from '@mui/material';

const HeadWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default HeadWrapper;
